import { Switch, SwitchProps } from '@mui/material';

export interface StatusSwitchProps extends Omit<SwitchProps, 'size'> {
  size?: 'small' | 'medium';
}

export function StatusSwitch(props: StatusSwitchProps) {
  return (
    <Switch
      {...props}
      size={props.size}
      sx={{
        '& .MuiSwitch-switchBase.Mui-checked, & .MuiSwitch-switchBase.Mui-checked.Mui-disabled': {
          color: (theme) => theme.palette.success.light,
        },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
          backgroundColor: (theme) => theme.palette.success.light,
        },
        '& .MuiSwitch-switchBase:not(.Mui-checked), & .MuiSwitch-switchBase:not(.Mui-checked).Mui-disabled':
          {
            color: (theme) => theme.palette.error.main,
          },
        '& .MuiSwitch-track': {
          backgroundColor: '#dc3545',
        },
        opacity: props.disabled ? 0.5 : undefined,
        marginLeft: -1.5,
        ...props.sx,
      }}
    />
  );
}
